import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || supabaseUrl.includes("DEIN-PROJEKT")) {
  console.warn("[supabase] VITE_SUPABASE_URL nicht gesetzt — Auth-Features deaktiviert");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
